import { breakpoints, theme } from '@notino/react-styleguide';

import ProgressBar from '@components/ProgressBar';
import { styled } from '@linaria/react';

export const ProgressWrapper = styled.div`
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RatingsValue = styled.div`
  display: flex;
  margin-right: 0.75rem;
`;

export const StarsBox = styled.div`
  display: inline-block;
`;

export const StarsValue = styled.div`
  display: inline-block;
  padding-right: 0.25rem;
  ${theme.typography.labelSmall400};
`;

export const ReviewsCount = styled.span`
  ${theme.typography.labelSmall400};
  color: ${theme.color.text.secondary};
`;

export const StarReviews = styled.div`
  @media (min-width: ${breakpoints.md}) {
    width: 40%;
  }
`;

export const StyledProgressBar = styled(ProgressBar)`
  width: calc(100% - 30px);
`;
